export default "__VITE_ASSET__uCSCyvzE__"